import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import noop from 'lodash/noop'
import {
    Column,
} from 'app/types/simpletable.types'
import useStyles from '../SimpleTable.styles'

const RowComponent = ({
    value,
    onChange: handleChange,
    columns: tableColumns,
    classNames,
}: {
    value: Record<string, any>[],
    columns: Column<any>[],
    onChange: (...a: any[]) => void,
    classNames: Record<string, any>
}) => {
    const {
        classes, cx,
    } = useStyles()

    return (
        <TableRow classes={{
            root: cx(classes.root, classNames.root),
        }}
        >
            {value && tableColumns.map(({
                fieldName,
                component: Component,
                getProps = noop,
                className,
            }) => {
                return (
                    <TableCell
                        classes={{
                            root: cx(classes.tableCell, classNames.tableCell, className),
                        }}
                        key={`field-${fieldName}`}
                    >
                        {Component ? (
                            <Component
                                value={value?.[fieldName]}
                                name={fieldName}
                                data-testid={`input-${fieldName}`}
                                onChange={handleChange}
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...getProps(value)}
                            />
                        ) : <span data-testid={`${fieldName}-value`}>{value?.[fieldName]}</span>}
                    </TableCell>
                )
            })}
        </TableRow>
    )
}

export default RowComponent
